/* Cómo se nombra a QUIÉN leyó un comprobante, sin revelar el modelo.
 *
 * `leido_por` guarda el modelo que hizo la lectura (hoy `claude-sonnet-5`). Al
 * usuario NO se le cuenta con qué se lee: es cómo está hecho por dentro, y la
 * regla del dueño (Igna, 20/09/2026) es no contárselo — «jamás darle datos del
 * estilo cómo lo hacemos». Lo que sí necesita saber es que ese dato lo sacó una
 * lectura AUTOMÁTICA y no una persona con el papel en la mano, porque los dos no
 * valen lo mismo. Así que el nombre del modelo se traduce a «lectura
 * automática».
 *
 * Si algún día figura una PERSONA como lector (su nombre, no un modelo), pasa
 * tal cual: lo que se esconde es la máquina, no el que corrigió.
 */
const ES_MODELO = /^(claude|gpt|gemini|haiku|opus|sonnet|o[0-9]|llama|mistral|deepseek|grok)/i;

export function etiquetaLeidoPor(v) {
  const s = String(v || "").trim();
  if (!s) return "";
  return ES_MODELO.test(s) ? "lectura automática" : s;
}
